import { render, staticRenderFns } from "./globalVCatalogImg.vue?vue&type=template&id=037879b3"
import script from "./globalVCatalogImg.vue?vue&type=script&lang=js"
export * from "./globalVCatalogImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports